import React, {Component} from "react"
import {Button, Dimmer, Loader, Item, Icon, Segment} from "semantic-ui-react"
import {Link} from "react-router-dom"
import _ from "lodash"
import MFR from "../presentation/MFR"
import Attachments from "./components/Attachments"
import api from "../api"
import TopNavigation from "./components/TopNavigation"
import { withTranslation } from 'react-i18next'

class DocumentsPage extends Component {

  constructor() {
    super()
    this.state = {
      order:   api.getOrder(),
      loading: false
    }
  }

  handleFiles = ({ files }) => {
    this.setState( { loading: true } )
    api.postDocument( { files } )
      .then( api.loadOrder )
      .then( (order) => {
        this.setState( { order, loading: false } )
      } )
  }

  render() {
    let { order, loading } = this.state
    let allDocs            = api.getAllAttachments()
    let documentNumber     = allDocs.documents.length
    let attachmentNumber   = allDocs.flatList.length
    const { t } = this.props;

    return (
      <div>
        <TopNavigation/>
        <div className="transition-item">
          <div className="section-full  ">
            <div className="pt3 ">
              <Segment>
                <Dimmer active={loading}>
                  <Loader>{t("general.upload.progress")}</Loader>
                </Dimmer>

                <Attachments
                  onChange={this.handleFiles}>
                  <Segment textAlign="center">
                    <div className="pt4 pb3">
                      <Button className="pb3" basic size="huge" circular icon="upload"/>
                      <div className="pa3">{t("general.add.filesDocuments")}</div>
                      <Button color="green">{t("general.add.files")}</Button>
                    </div>
                  </Segment>
                </Attachments>
              </Segment>
            </div>

            <Segment>
              <div>{documentNumber} {t("general.document", {count: documentNumber})} {t("general.in.appendix")}
                { attachmentNumber > 0 ?
                  <div className="fr-m fr-l black-60">({t("general.plus")} {attachmentNumber} {t("general.document", {count: attachmentNumber})} {t("general.in.report")})</div> : null}
              </div>
            </Segment>

            <Segment >
              <Item.Group divided>
                {documentCategory( { documents: order.Documents } )}
                {/*{docsAttachedToSteps}*/}
              </Item.Group>
            </Segment>

            <div className="tr pb4">
              <Link to="/tasks">
                <Button basic inverted  icon="chevron left"/>
              </Link>
              <Link to="/sign">
                <Button color='green' className="no-margin-right">
                  {t("general.check")}<Icon name="chevron right"/>
                </Button></Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation()(DocumentsPage)

const documentCategory = ({ documents, step = false }) => {
  return _.map( documents, (doc, key) => <MFR.ItemDocument document={doc}
                                                           key={key}
                                                           step={step}/> )
}



// WEBPACK FOOTER //
// ./src/pages/DocumentsPage.js